import { Component } from '@angular/core';

@Component({
  selector: 'uni-table-top-bar-checkbox',
  templateUrl: './uni-table-top-bar-checkbox.component.html',
  styleUrls: ['./uni-table-top-bar-checkbox.component.scss']
})
export class UniTableTopBarCheckboxComponent {}
